<template>
  <div>		
		<div class="pg-header">
			<div>
				<label class="title">角色权限管理</label>
			</div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>系统管理</span>|
					<span class="active">角色权限管理</span>
				</div>
				<!-- <a class="back noline" @click="goBack">返回</a> -->
			</div>
		</div>
		
		<div class="table-wrap">
			<div class="action-bar">
				<el-button type="primary" size="mini" style="margin-top: 10px" round @click="showDlg">新增角色</el-button>
			</div>
			<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border :data="list.data" v-loading="isLoading" @selection-change="selectionChange">
				<!-- <el-table-column fixed="left" type="selection" width="55"></el-table-column> -->
				<el-table-column prop="id" label="角色id" show-overflow-tooltip ></el-table-column>
				<el-table-column prop="roleName" label="角色名称" show-overflow-tooltip ></el-table-column>
				<el-table-column prop="roleType" label="数据权限" width="200" show-overflow-tooltip>
					<template slot-scope="scope">
						<span v-if="scope.row.roleType === 0">本人患者</span>
						<span v-else>全科患者</span>
					</template>
				</el-table-column>

				<el-table-column prop="reviserName" label="更新人" width="200"></el-table-column>
				<el-table-column prop="date" label="更新记录时间" width="200"></el-table-column>
				<el-table-column fixed="right" label="操作" width="200">
					<template slot-scope="scope">
						<div class="tab-action">
							<!-- <el-tooltip content="查看" placement="top" :enterable="false"><router-link target='_blank' :to="{name: 'System/ScheduleTemplateView', query: {templateId: scope.row.id}}"><i class="icon-research"></i></router-link></el-tooltip> -->
							<el-tooltip content="修改" placement="top" :enterable="false"><i class="el-icon-edit-outline" @click="showDlg(scope.row)"></i></el-tooltip>
							<el-popconfirm confirmButtonText='删除' title="确定删除吗？"  @confirm="delItem(scope.row)">
								<el-tooltip content="删除" slot="reference" placement="top" :enterable="false"><i class="el-icon-delete"></i></el-tooltip>
							</el-popconfirm>
						</div>
					</template>
				</el-table-column>
			</el-table>	
			<div class="pagination">
				<el-row>
					<el-col :span="12">
						<div class="record">当前是第<span v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span v-text="(filter.pageNumber-1)*filter.pageSize+filter.pageSize"></span>数据</div>
						<div class="record">总计<span v-text="list.total"></span>条记录</div>
					</el-col>
					<el-col :span="12" style="text-align: right;">
						<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"  prev-text="上一页" next-text="下一页" :current-page="list.current" :page-size="filter.pageSize" :total="list.total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
					</el-col>
				</el-row>
			</div>
		</div>

		<el-dialog :title="form.id > 0 ? '修改角色' : '新增角色'" width="530px" center :visible.sync="dlg.active" :close-on-click-modal="false">
			<el-form ref="form" label-width="120px" :rules="dlg.rules" :model="form">
				<el-form-item label="角色名称" prop="roleName">
					<el-input v-model="form.roleName"></el-input>
				</el-form-item>

				<el-form-item label="数据权限" prop="roleType">
					<el-radio-group v-model="form.roleType">
						<el-radio :label="0">本人患者</el-radio>
						<el-radio :label="1">全科患者</el-radio>
					</el-radio-group>
				</el-form-item>

				<el-form-item label="菜单权限" prop="menuIds">
					<el-tree ref="tree" node-key="id"  show-checkbox :props="{ label: 'name' }" :data="menuTree"></el-tree>
				</el-form-item>

			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button type="primary" :loading="isLoading" @click="saveForm">保 存</el-button>
			</div>
		</el-dialog>
		
		
  </div>
	
			
</template>

<script>
// import HelloWorld from '@/components/HelloWorld.vue'
import mixin from '@/views/mixin';
import api from '@/service/api.js';
import dayjs from 'dayjs';

export default {
	mixins: [mixin],
	data(){
		return {
			dlg: {
				active: false,
				rules: {
					roleName: {required: true, message: '请输入', trigger: 'blur'},
					roleType: {required: true, message: '请选择', trigger: 'change'},
					// menuIds: {required: true, message: '请选择', trigger: 'change'},
				}
			},
			menuTree: undefined,
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null
			},
			filter: {
				// name: '',
				// departmentId:'',
				pageNumber: 1,
				pageSize: 10
			},
			form: {
				roleName: '',
				roleType: undefined,
				menuIds: undefined
			},
		}
	},
	created() {
		this.loadList();

		this.loadMenuTree();
	},
	methods: {
		async loadList() {
			this.isLoading = true;
			let res = await api.getRoleList(this.filter);
			if (res.code == 500) {return this.$router.push({name: 'Login', query: {r: location.href}});}
			this.list.total = +res.total;
			this.list.current = this.filter.pageNumber;
			this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
			if (res.data) {
				res.data.forEach((item)=>{
					item.date = dayjs(item.updateTime).format('YYYY-MM-DD HH:mm:ss');
				})
				this.list.data = res.data;
			}
			this.isLoading = false;
		},
		async loadMenuTree() {
			let res = await api.getMenuTree();
			if (res.code == 500) {return this.$router.push({name: 'Login', query: {r: location.href}});}
			this.menuTree = res.data;
		},
		showDlg(item) {
			this.dlg.active = true;
			if (item && item.id > 0) {
				this.$nextTick(async ()=>{
					let res = await api.getRole(item.id);
					if (res.code == 500) {return this.$router.push({name: 'Login', query: {r: location.href}});}
					this.form = res.data;
					this.$refs['form'].resetFields();

					this.$refs.tree.setCheckedKeys(this.form.menus?.map(item => { 
						if (item.parentId > 0 || item.menuType === 1) { 
							return item.id;
						} 
					}));
				});
			} else {
				this.form.id = 0;
				this.$nextTick(()=>{
					this.$refs['form'].resetFields();
					this.$refs.tree.setCheckedKeys([]);//新增角色，把菜单tree置空
				});
			}
		},
		closeDlg() {
			this.dlg.active = false;
		},
		async saveForm() {
			let res;
			this.$refs['form'].validate(async (valid)=>{
				if (valid) {
					let postForm = {
						roleName: this.form.roleName,
						roleType: this.form.roleType,
						description: this.form.description,
						menuIds: this.$refs.tree.getCheckedNodes(false, true),
					}

					if (this.form.id > 0) {
						postForm.roleId = this.form.id;
						postForm.menuIds = postForm.menuIds?.map((item)=> item.id)?.join(',')
						// postForm.menuIds = postForm.menuIds.join(',');
						res = await api.editRole(postForm);
					} else {
						// 后端问题，不能带这参数
						this.form.id = null;
						postForm.menuIds = postForm.menuIds?.map((item)=> item.id)?.join(',')
						res = await api.addRole(postForm);
					}
					if (res.code != 1000) {
						this.$message.error(res.message);
						return;
					}
					this.loadList();
					this.$message({message: '保存成功',type: 'success'});
					this.closeDlg();
				}
			})
		},
		async delItem(item) {
			let res;
			if (this.isLoading) { return;}
			
			this.isLoading = true;
			if (item && item.id > 0) {
				res = await api.delRole(item.id);
			} else {
				// 批量删除
				if (this.multipleSelection.length == 0) {
					this.isLoading = false;
					return this.$message.warning('未选择任何数据');
				}
				res = await api.delScheduleTemplate({ids: this.multipleSelection.join(',')});
			}
			if (res.code != 1000) {
				this.isLoading = false;
				return this.$message.error(res.message);
			}
			this.isLoading = false;
			this.$message({message: '已删除',type: 'success'});
			this.loadList();
		},
		// 过滤条件 更改
		handleFilter(key, val) {
			this.filter.pageNumber = 1;
			this.loadList();
		},			
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		}
	}
}
</script>

<style lang="less" scoped>
@import '@/assets/style/var';
</style>
